import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { usePaymentDetails } from '../../hooks/usePaymentQueries';
import Button from '../common/Button';
import './PaymentModal.css';

const PaymentModal = ({ isOpen, onClose, paymentLink, paymentId, status }) => {
  const [showQR, setShowQR] = useState(false);
  const { data: paymentDetails } = usePaymentDetails(paymentId, { enabled: isOpen && !paymentLink });
  
  // Use payment link from props, or fetch from payment details if not available
  const actualPaymentLink = paymentLink || paymentDetails?.payment_link_url || paymentDetails?.payment_link;
  const actualStatus = status || paymentDetails?.employer_payment_status;

  useEffect(() => {
    if (!isOpen) {
      setShowQR(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handlePayNow = () => {
    if (actualPaymentLink) {
      window.open(actualPaymentLink, '_blank', 'noopener,noreferrer');
    }
  };

  const isPaid = actualStatus === 'employer_paid';

  return (
    <div className="payment-modal__overlay" onClick={onClose}>
      <div className="payment-modal__content" onClick={(e) => e.stopPropagation()}>
        <div className="payment-modal__header">
          <h3 className="payment-modal__title">Payment</h3>
          <button className="payment-modal__close" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="payment-modal__body">
          {isPaid ? (
            <div className="payment-modal__paid-message">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
              <p>Payment completed successfully.</p>
            </div>
          ) : (
            <>
              <div className="payment-modal__actions">
                <Button
                  variant="primary"
                  size="large"
                  onClick={handlePayNow}
                  className="payment-modal__button"
                >
                  Pay Now
                </Button>
                <Button
                  variant="secondary"
                  size="medium"
                  onClick={() => setShowQR(!showQR)}
                  className="payment-modal__button"
                >
                  {showQR ? 'Hide QR Code' : 'Show QR Code'}
                </Button>
              </div>

              {showQR && actualPaymentLink && (
                <div className="payment-modal__qr">
                  <QRCodeSVG value={actualPaymentLink} size={200} />
                  <p className="payment-modal__qr-instruction">
                    Scan with your mobile device to pay
                  </p>
                </div>
              )}

              {!actualPaymentLink && (
                <div className="payment-modal__no-link">
                  <p>Payment link is being generated. Please try again in a moment.</p>
                </div>
              )}

              <div className="payment-modal__instructions">
                <p className="payment-modal__instruction-text">
                  Click "Pay Now" to complete your payment securely via Stripe.
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;

